import React from 'react';

const ListItem = ({ children, onMouseLeave }) => (
  <li className="py-[7px] mx-0 cursor-pointer box-content" onMouseLeave={onMouseLeave}>
    {children}
  </li>
);

export default ListItem;
